export enum BackendProjectRole {
    OWNER = 'owner',
    COLLABORATOR = 'project_collaborator',
    VIEWER = 'project_viewer',
}

export enum ProjectRole {
    OWNER = 'Owner',
    EDITOR = 'Editor',
    VIEWER = 'Viewer',
}

export enum PlatformType {
  TylerAppPlatform = "TylerAppPlatform",
  ServiceNow = "ServiceNow",
  PowerApps = "PowerApps",
  Salesforce = "Salesforce",
}

export interface FedRampProject {
  _id: string;
  title: string;
  description: string;
  project_type: number;
  tap_url?: string;
  app_secret?: string;
  app_id?: string;
  created_at: string;
  user_id: string;
  total_cost: number;
  platform_type?: PlatformType;
  permissions?: string[];
};

export const mapBackendRoleToUiRole = (backendRole: string): ProjectRole => {
    switch (backendRole) {
        case BackendProjectRole.OWNER:
            return ProjectRole.OWNER;
        case BackendProjectRole.COLLABORATOR:
            return ProjectRole.EDITOR;
        case BackendProjectRole.VIEWER:
            return ProjectRole.VIEWER;
        default:
            return ProjectRole.EDITOR;
    }
};
